import { useContext } from 'react';
import { ThemeContext } from 'styled-components';

type Customizations = {
  showExternalActions: boolean;
  showHeader: boolean;
  showFooter: boolean;
  showPoweredBy: boolean;
  hideCovaxEligibleTypeWarning: boolean;
};

export const useWhiteLabelCustomisations = (): Customizations => {
  const { whiteLabelProps } = useContext(ThemeContext);
  const isPoweredBy = !!whiteLabelProps?.poweredByHE;
  const hasBaseRoute = !!whiteLabelProps?.baseRoute;
  const whitelabelled = !!whiteLabelProps?.themeIsPresent;

  return {
    showFooter: !isPoweredBy,
    showPoweredBy: isPoweredBy,
    showExternalActions: !hasBaseRoute,
    showHeader: whitelabelled,
    hideCovaxEligibleTypeWarning: whitelabelled,
  };
};
